/**
 * @file  vsc/routes/config.ts
 * @description  defines the routes for the vsc product
 * @author ogarcia (ozkary)
 *
 */

/**
 * @description add each route to component mappig below.
 */
import baseRoutes from '../../routes/baseConfig';
const basePath = '';
const routes = [
  {
    path: ['/', '/login'],
    exact: false,
    component: `${basePath}/Home`
  },
  {
    path: ['/home', '/vehicle'],
    exact: false,
    component: `${basePath}/Vehicle`
  },
  {
    path: ['/mileage'],
    exact: false,
    component: `${basePath}/Mileage`
  },
  {
    path: ['/coverage'],
    exact: false,
    component: `${basePath}/Coverages`
  },
  {
    path: ['/options'],
    exact: false,
    component: `${basePath}/Options`
  }
];

// add the base routes
// const mergedRoutes = routes.concat(baseRoutes);

// export the route mapping
export default routes;
export { baseRoutes };
